define('modules/setup',["jquery", "app"], function($, App) {
    var expireTimer = null;

    function checkDeviceInfo(info) {
        var missing = [];
        if(!info.store) {
            missing.push('Store');
        }
        if(missing.length) {
            var last, message = '';
            if(missing.length== 1) {
                message += missing[0] + ' is ';
            } else {
                last= missing.pop();
                message += missing.join(', ') + ' and ' + last + ' are ';
            }
            App.page.render('message', '<h2>Missing Device Information</h2><p>' + message + 'missing. Please update in admin and reload the page.</p>');
            return false;
        }
        return true;
    }

    var checkExpiry = (function() {
        var failedChecks = 0;

        function onFail(callback) {
            failedChecks++;
            if(failedChecks < 24) {
                setTimeout(function() {
                    checkExpiry(callback);
                },  3600000);
            } else {
                App.page.login({
                    onLogin : function() {
                        Setup.fetchDeviceInfo(function() {
                            Setup.checkLocationAndReload();
                        });
                    },
                    message : "Unable to connect to network"
                });
            }
        }

        return function (callback) {
            if(navigator.onLine) {
                App.api.call('/device.checkExpiry', {
                    id : App.global('device_id'),
                    retailer_id : App.global('retailer_id')
                }, function(response) {
                    failedChecks = 0;
                    App.global('expires_on', response.expires_on);

                    var nextInterval = callback(response.expires_on);
                    if(nextInterval) {
                        setTimeout(function(){
                            checkExpiry(callback);
                        }, nextInterval);
                    }
                }).fail(function(){
                    onFail(callback);
                });
            } else {
                onFail(callback);
            }
        }
    })();

    var Setup = {
        reset : function(complete) {
            var clearProducts = App.database.instance.products.clear();
            var clearParams;
            if(complete != undefined && !complete) {
                clearParams = App.database.instance.params.where('name').noneOf(['user', 'retailer_logo']).delete();
            }
            else {
                clearParams = App.database.instance.params.clear();
            }
            return Promise.all([clearProducts, clearParams]);
        },
        unregister : function(notifyServer, callback) {
            App.page.render('spinner', 'Please wait while we are unregistering the device. This may take few moments...', true);

            var promises = [this.reset()];
            if(notifyServer) {
                promises.push(new Promise(function(resolve) {
                    App.api.call('/device.unregister', {id : App.global('device_id')}, resolve, resolve);
                }));
            }

            Promise.all(promises).then(function() {
                if(typeof callback != 'function') {
                    location.reload();
                } else {
                    callback();
                }
            });
        },
        fetchDeviceInfo : function(callback) {
            var that = this;
            App.page.render('spinner', 'Fetching Device Information...', true);
            App.api.call('/device.getDetails', {id : App.global('device_id')}, function(response) {
                var currentStore = App.global('store');
                var setParams = {
                    'store' : response.store ? response.store.id : undefined,
                    'map_source' : response.location || null,
                    'map_floor' : response.floor || null,
                };
                App.database.set(setParams).then(function(){
                    if(checkDeviceInfo(setParams)) {
                        if(setParams.store != currentStore) {
                            App.page.render('spinner', (currentStore ? '<h2>Store changed</h2>' : '') + '<p>Please wait while we are preparing this device for new store...</p>', true);
                            that.reset(false).then(function(){
                                setParams.retailer_id = App.global('retailer_id');
                                setParams.device_id = App.global('device_id');
                                App.database.set(setParams).then(function(){
                                    that.updateData();
                                });
                            });
                        } else {
                            if(callback) {
                                if(typeof callback == 'string') {
                                    that.updateData(callback);
                                } else if(typeof callback == 'function') {
                                    callback();
                                }
                            } else {
                                that.updateData();
                            }
                        }
                    }
                });
            }, function(message) {
                App.page.render('message', '<h4>' + message + '</h4>');
            });
        },
        checkExpiry : function(callback) {
            var that = this;
            var first = true;

            checkExpiry(function(timestamp) {
                var now = Date.now();
                if(!timestamp || timestamp <= now) {
                    if(first) {
                        that.unregister(false, function(){
                            App.page.render('message', '<h2>Your subscription has expired</h2><p>Please update your subscription and Register this device again.</p>');
                        });
                    } else {
                        location.reload();
                    }
                    return;
                } else {
                    if(first) {
                        first = false;
                        callback();
                    }

                    if(timestamp - now > 86400000) {
                        return 86400000;
                    } else {
                        return timestamp - now;
                    }
                }
            });
        },
        updateData : function(data) {
            App.page.render('loader', {load: data}, true);
        },
        updateLocation : function() {
            App.page.render('map', {mode : 'location'});
        },
        checkLocationAndReload : function() {
            if(!App.global('map_source') || App.global('map_floor') == null) {
                this.updateLocation();
            } else {
                location.reload();
            }
        }
    };

    return Setup;
});
